import {useRef} from 'react';
import {PageBodyManagerRef} from './types';

export function usePageBodyManagerRef() {
	return useRef<PageBodyManagerRef>(null);
}
